import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  CalendarToday as EnteredIcon,
  Schedule as ScheduledIcon,
} from '@mui/icons-material';
import { formatJobEnteredAt, formatJobScheduledFor } from '../utils/jobSchedule';

/**
 * Shows entered-in-system and scheduled-for-work as two separate rows.
 */
export default function JobEnteredScheduledDates({
  job,
  variant = 'card',
  sx,
}) {
  const entered = formatJobEnteredAt(job);
  const scheduled = formatJobScheduledFor(job);
  const empty = 'Not set';

  const labelProps =
    variant === 'detail'
      ? { variant: 'subtitle2', sx: { fontWeight: 600, color: 'text.secondary', mb: 0.5 } }
      : { variant: 'caption', sx: { fontWeight: 600, color: 'text.secondary', display: 'block', lineHeight: 1.2 } };

  const valueProps =
    variant === 'detail'
      ? { variant: 'body1', sx: { color: 'text.primary' } }
      : { variant: 'body2', sx: { color: 'text.secondary', lineHeight: 1.4 } };

  const Row = ({ icon, label, value }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
      {icon}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography {...labelProps}>{label}</Typography>
        <Typography {...valueProps}>{value || empty}</Typography>
      </Box>
    </Box>
  );

  const iconSx = { fontSize: variant === 'detail' ? 20 : 16, color: 'text.secondary', mt: variant === 'detail' ? 0.25 : 0.2 };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: variant === 'detail' ? 2 : 1, ...sx }}>
      <Row
        icon={<EnteredIcon sx={iconSx} />}
        label="Entered in system"
        value={entered}
      />
      <Row
        icon={<ScheduledIcon sx={iconSx} />}
        label="Scheduled for work"
        value={scheduled}
      />
    </Box>
  );
}
